<template lang="pug">

  .switch-component(:class="{ 'sosSwitch--disabled': disabled }")
    label(v-if="label" :disabled="disabled" @click="handleClick")
      | {{ label }}
    .switch-container(:active="value" :disabled="disabled" @click="handleClick")
      .switch(:active="value")

</template>

<script>
  // sos-switch(:value="aaa" @click="bbb" :label="ddd")
  // sos-switch(:value="aaa" @click="bbb" :disabled="ccc")
  // sos-switch(:value="aaa" @click="bbb" :disabled="ccc")

  export default {
    name: 'SosSwitch',

    props: {
      value: {
        type: Boolean,
        required: true,
      },
      label: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      handleClick () {
        if (this.disabled) return false

        const { value } = this

        this.$emit('click', !value)

        return true
      },
    },
  }
</script>
